import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../../components/HeaderCustom";
import { Alert, Backdrop, CircularProgress, Snackbar } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getDetalleVale, postCrearVale, postUpdateVale } from "../../../../api/ApiService";
import dayjs from "dayjs";
import "dayjs/locale/es";

function ValeAddPage() {
    const [cargando, setCargando] = useState(false);
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState("");
    const [mensaje, setMensaje] = useState("");
    const [loadingGuardar, setLoadingGuardar] = useState(false);

    const [nombre, setNombre] = useState("");
    const [comprasDesde, setComprasDesde] = useState("");
    const [comprasHasta, setComprasHasta] = useState("");
    const [canjesDesde, setCanjesDesde] = useState("");
    const [canjesHasta, setCanjesHasta] = useState("");
    const [ratioNormal, setRatioNormal] = useState("");
    const [ratioItau, setRatioItau] = useState("");
    const [ratioItauPersonalBank, setRatioItauPersonalBank] = useState("");
    const [montoMinimoCompra, setMontoMinimoCompra] = useState("");
    const [montoMaximoCompras, setMontoMaximoCompras] = useState("");
    const [porcentajeLocales, setPorcentajeLocales] = useState("");
    const [mostrarAlLocatario, setMostrarAlLocatario] = useState(true);
    const [esPrueba, setEsPrueba] = useState(false);

    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get("mode");
    const isViewMode = mode === "view";

    const navigate = useNavigate();

    const stateToken = useSelector((state) => state.reducerGlobal.token);

    const openAlert = (type, text) => {
        setSeverity(type);
        setMensaje(text);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleCancelar = () => {
        window.history.back();
    };

    const toDateTimeInputValue = (value) => {
        if (!value) return "";
        // Convierte formatos ISO/backend a datetime-local (YYYY-MM-DDTHH:mm).
        const normalized = String(value).replace(" ", "T");
        return normalized.substring(0, 16);
    };

    const toApiDateTime = (value) => {
        if (!value) return "";
        // Convierte datetime-local a formato enviado al backend: YYYY-MM-DD HH:mm:ss.
        const base = value.replace("T", " ");
        return base.length === 16 ? `${base}:00` : base;
    };

    const handleDetalleVale = () => {
        getDetalleVale(stateToken?.access_token, id)
            .then((response) => {
                const data = response || {};

                setNombre(data?.nombre || "");
                setComprasDesde(toDateTimeInputValue(data?.compras_desde));
                setComprasHasta(toDateTimeInputValue(data?.compras_hasta));
                setCanjesDesde(toDateTimeInputValue(data?.canjes_desde));
                setCanjesHasta(toDateTimeInputValue(data?.canjes_hasta));
                setRatioNormal(data?.ratio_normal ?? "");
                setRatioItau(data?.ratio_itau ?? "");
                setRatioItauPersonalBank(data?.ratio_itau_personal_bank ?? "");
                setMontoMinimoCompra(data?.monto_minimo_compra ?? "");
                setMontoMaximoCompras(data?.monto_maximo_compras ?? "");
                setPorcentajeLocales(data?.porcentaje_locales ?? "");
                setMostrarAlLocatario(Boolean(data?.mostrar_al_locatario));
                setEsPrueba(Boolean(data?.es_prueba));
                setCargando(true);
            })
            .catch((error) => {
                console.log("error-getDetalleVale", error);
                openAlert("error", "Error al cargar los datos del vale");
                setCargando(true);
            });
    };

    useEffect(() => {
        if (!stateToken?.access_token) {
            return;
        }

        if (id) {
            handleDetalleVale();
        } else {
            setCargando(true);
        }
    }, [id, stateToken]);

    const validateFields = () => {
        if (!nombre.trim()) {
            openAlert("warning", "El campo nombre es obligatorio");
            return false;
        }
        if (!comprasDesde || !comprasHasta || !canjesDesde || !canjesHasta) {
            openAlert("warning", "Debes completar todas las fechas");
            return false;
        }
        // if (Number(ratioNormal) <= 0 || Number(ratioItau) <= 0 || Number(ratioItauPersonalBank) <= 0) {
        //     openAlert("warning", "Los ratios deben ser mayores a 0");
        //     return false;
        // }
        if (Number(montoMinimoCompra) <= 0 || Number(montoMaximoCompras) <= 0) {
            openAlert("warning", "Los montos deben ser mayores a 0");
            return false;
        }
        if (Number(montoMaximoCompras) < Number(montoMinimoCompra)) {
            openAlert("warning", "El monto maximo no puede ser menor al monto minimo");
            return false;
        }
        if (Number(porcentajeLocales) < 0) {
            openAlert("warning", "El porcentaje de locales no puede ser negativo");
            return false;
        }
        return true;
    };

    const buildBody = () => {
        return {
            nombre: nombre.trim(),
            compras_desde: toApiDateTime(comprasDesde),
            compras_hasta: toApiDateTime(comprasHasta),
            canjes_desde: toApiDateTime(canjesDesde),
            canjes_hasta: toApiDateTime(canjesHasta),
            ratio_normal: Number(ratioNormal),
            ratio_itau: Number(ratioItau),
            ratio_itau_personal_bank: Number(ratioItauPersonalBank),
            monto_minimo_compra: Number(montoMinimoCompra),
            monto_maximo_compras: Number(montoMaximoCompras),
            porcentaje_locales: Number(porcentajeLocales),
            mostrar_al_locatario: mostrarAlLocatario ? 1 : 0,
            es_prueba: esPrueba ? 1 : 0,
        };
    };

    const handleUpdateValeApi = (body) => {
        postUpdateVale(stateToken?.access_token, body, id)
            .then(() => {
                openAlert("success", "Guardado con exito");
                setTimeout(() => {
                    navigate('/app/admin/paseo-plus/vales');
                }, 1500);
            })
            .catch((error) => {
                console.log("error-postUpdateVale", error);
                openAlert("error", "Error al guardar el vale");
            })
            .finally(() => {
                setLoadingGuardar(false);
            });
    };

    const handleAddValeApi = (body) => {
        postCrearVale(stateToken?.access_token, body)
            .then(() => {
                openAlert("success", "Guardado con exito");
                setNombre("");
                setComprasDesde("");
                setComprasHasta("");
                setCanjesDesde("");
                setCanjesHasta("");
                setRatioNormal("");
                setRatioItau("");
                setRatioItauPersonalBank("");
                setMontoMinimoCompra("");
                setMontoMaximoCompras("");
                setPorcentajeLocales("");
                setMostrarAlLocatario(true);
                setEsPrueba(false);
                setTimeout(() => {
                    navigate('/app/admin/paseo-plus/vales');
                }, 1500);
            })
            .catch((error) => {
                console.log("error-postCrearVale", error);
                openAlert("error", "Error al guardar el vale");
            })
            .finally(() => {
                setLoadingGuardar(false);
            });
    };

    const handleGuardar = () => {
        if (isViewMode) {
            return;
        }

        if (!validateFields()) {
            return;
        }

        const body = buildBody();
        setLoadingGuardar(true);

        if (id) {
            handleUpdateValeApi(body);
        } else {
            handleAddValeApi(body);
        }
    };

    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
                <div className="max-w-5xl mx-auto">
                    <div className="mb-6">
                        <h1 className="text-2xl font-bold text-gray-800 mb-1">
                            {isViewMode ? "Detalle del Vale" : id ? "Editar Vale" : "Agregar Vale"}
                        </h1>
                    </div>

                    {cargando ? (
                        <div className="bg-white rounded-xl shadow-xl overflow-hidden">
                            <form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    handleGuardar();
                                }}
                            >
                                <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Nombre</label>
                                        <input
                                            type="text"
                                            value={nombre}
                                            onChange={(e) => setNombre(e.target.value)}
                                            placeholder="Ej: Paseo Plus 2026"
                                            disabled={isViewMode}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm disabled:bg-gray-100"
                                            required
                                        />
                                    </div>

                                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Compras desde</label>
                                            <DateTimePicker
                                                ampm={false}
                                                value={comprasDesde ? dayjs(comprasDesde) : null}
                                                onChange={(newValue) => setComprasDesde(newValue ? newValue.format("YYYY-MM-DDTHH:mm") : "")}
                                                disabled={isViewMode}
                                                format="DD/MM/YYYY HH:mm"
                                                slotProps={{
                                                    textField: {
                                                        required: true,
                                                        fullWidth: true,
                                                        size: "small",
                                                    },
                                                }}
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Compras hasta</label>
                                            <DateTimePicker
                                                ampm={false}
                                                value={comprasHasta ? dayjs(comprasHasta) : null}
                                                onChange={(newValue) => setComprasHasta(newValue ? newValue.format("YYYY-MM-DDTHH:mm") : "")}
                                                disabled={isViewMode}
                                                format="DD/MM/YYYY HH:mm"
                                                slotProps={{
                                                    textField: {
                                                        required: true,
                                                        fullWidth: true,
                                                        size: "small",
                                                    },
                                                }}
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Canjes desde</label>
                                            <DateTimePicker
                                                ampm={false}
                                                value={canjesDesde ? dayjs(canjesDesde) : null}
                                                onChange={(newValue) => setCanjesDesde(newValue ? newValue.format("YYYY-MM-DDTHH:mm") : "")}
                                                disabled={isViewMode}
                                                format="DD/MM/YYYY HH:mm"
                                                slotProps={{
                                                    textField: {
                                                        required: true,
                                                        fullWidth: true,
                                                        size: "small",
                                                    },
                                                }}
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Canjes hasta</label>
                                            <DateTimePicker
                                                ampm={false}
                                                value={canjesHasta ? dayjs(canjesHasta) : null}
                                                onChange={(newValue) => setCanjesHasta(newValue ? newValue.format("YYYY-MM-DDTHH:mm") : "")}
                                                disabled={isViewMode}
                                                format="DD/MM/YYYY HH:mm"
                                                slotProps={{
                                                    textField: {
                                                        required: true,
                                                        fullWidth: true,
                                                        size: "small",
                                                    },
                                                }}
                                            />
                                        </div>
                                    </LocalizationProvider>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Ratio normal</label>
                                        <input
                                            type="number"
                                            min="0"
                                            step="0.001"
                                            value={ratioNormal}
                                            onChange={(e) => setRatioNormal(e.target.value)}
                                            disabled={isViewMode}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm disabled:bg-gray-100"
                                            required
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Ratio Itaú</label>
                                        <input
                                            type="number"
                                            min="0"
                                            step="0.001"
                                            value={ratioItau}
                                            onChange={(e) => setRatioItau(e.target.value)}
                                            disabled={isViewMode}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm disabled:bg-gray-100"
                                            required
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Ratio Itaú Personal Bank</label>
                                        <input
                                            type="number"
                                            min="0"
                                            step="0.001"
                                            value={ratioItauPersonalBank}
                                            onChange={(e) => setRatioItauPersonalBank(e.target.value)}
                                            disabled={isViewMode}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm disabled:bg-gray-100"
                                            required
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Monto mínimo compra</label>
                                        <input
                                            type="text"
                                            // min="0"
                                            // step="1"
                                            value={montoMinimoCompra ? Number(montoMinimoCompra).toLocaleString("es-PY") : ""}
                                            // onChange={(e) => setMontoMinimoCompra(e.target.value)}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/[\.,]/g, "");
                                                if (/^\d*$/.test(value)) {
                                                    setMontoMinimoCompra(value);
                                                }
                                            }}
                                            disabled={isViewMode}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm disabled:bg-gray-100"
                                            required
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Monto máximo compras</label>
                                        <input
                                            type="text"
                                            min="0"
                                            step="1"
                                            // value={montoMaximoCompras}
                                            //formatear en la moneda local PYG
                                            value={montoMaximoCompras ? Number(montoMaximoCompras).toLocaleString("es-PY") : ""}
                                            // onChange={(e) => setMontoMaximoCompras(e.target.value)}
                                            //permitir solo numeros y que se borre el valor al poner 0
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/[\.,]/g, "");
                                                if (/^\d*$/.test(value)) {
                                                    setMontoMaximoCompras(value);
                                                }
                                            }}

                                            disabled={isViewMode}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm disabled:bg-gray-100"
                                            required
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Porcentaje locales</label>
                                        <input
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            value={porcentajeLocales}
                                            onChange={(e) => setPorcentajeLocales(e.target.value)}
                                            disabled={isViewMode}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm disabled:bg-gray-100"
                                            required
                                        />
                                    </div>

                                    <div className="flex flex-col gap-3 pt-6">
                                        <label className="inline-flex items-center gap-2 text-sm text-gray-700">
                                            <input
                                                type="checkbox"
                                                checked={mostrarAlLocatario}
                                                onChange={(e) => setMostrarAlLocatario(e.target.checked)}
                                                disabled={isViewMode}
                                                className="h-4 w-4 rounded border-gray-300 text-[#104063] focus:ring-[#104063]"
                                            />
                                            Mostrar al locatario
                                        </label>

                                        <label className="inline-flex items-center gap-2 text-sm text-gray-700">
                                            <input
                                                type="checkbox"
                                                checked={esPrueba}
                                                onChange={(e) => setEsPrueba(e.target.checked)}
                                                disabled={isViewMode}
                                                className="h-4 w-4 rounded border-gray-300 text-[#104063] focus:ring-[#104063]"
                                            />
                                            Es prueba
                                        </label>
                                    </div>
                                </div>

                                <div className="flex justify-start gap-3 p-6 border-t border-gray-200">
                                    {!isViewMode && (
                                        <button
                                            type="submit"
                                            className="px-6 py-2 bg-[#104063] hover:bg-[#0d3553] text-white rounded-lg font-medium transition-colors"
                                            disabled={loadingGuardar}
                                        >
                                            {loadingGuardar ? "Guardando..." : id ? "Guardar cambios" : "Guardar"}
                                        </button>
                                    )}

                                    <button
                                        type="button"
                                        onClick={handleCancelar}
                                        className="px-6 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors"
                                    >
                                        {isViewMode ? "Volver" : "Cancelar"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <div className="bg-white rounded-xl shadow-md p-8">
                            <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                            <div className="space-y-4">
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-24 bg-gray-200 rounded animate-pulse" />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <Backdrop open={loadingGuardar} sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2500} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled">
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default ValeAddPage;
